import { loadingIcon } from '../../../assets/images';
import { isMobile } from '../../../utils/utils';
import './index.scss';

const ContainedLoading = (props) => {

    const mobile = isMobile(window);
    return (
        <div className={`contained-loading-container ${props.transparentBackground ? '!bg-transparent' : ''}`}>
            <img src={loadingIcon}/>
        </div>
    )  
}

export default ContainedLoading;